module.exports = __webpack_public_path__ + "img/562-42dfb3.png";